import api from "./client";

export default {
    recover(data) {
        return api.post('/recover', data);
    },
    uploadPhoto(user_id, options) {
        return api.post('/upload/photo/' + user_id, options);
    },
    deleteVideo(user_id) {
        return api.get('/edit/deleteVideo/' + user_id);
    },
    getOverview(section, user_id) {
        return api.get('/edit/getOverview/' + section + '/' + user_id);
    },
    getGallery(user_id) {
        return api.get('/edit/getGallery/' + user_id);
    },
    deleteMedia(user_id, media_id) {
        return api.post('/edit/deleteMedia/' + user_id, {id: media_id});
    },
    updateGalleryPos(user_id, data) {
        return api.post('/edit/updateGalleryPos/' + user_id, {gallery: data});
    },
    uploadVideo(user_id, file) {
        let formData = new FormData();
        formData.append("file", file);
        return api.post('/upload/video/' + user_id, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    setAttribute(user_id, data) {
        return api.post('/edit/setAttribute/' + user_id, data);
    },
    getAttribute(user_id, data) {
        return api.post('/edit/getAttribute/' + user_id, data);
    },
    getUpdateData(hash) {
        return api.get('/getUpdateData/' + hash);
    },
    update(data) {
        return api.post('/update', data);
    }

}

